import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import HostNew from "@/pages/HostNew";
import HostGame from "@/pages/HostGame";
import Join from "@/pages/Join";
import TeamRoom from "@/pages/TeamRoom";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#121212",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.15)",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.05em",
            textTransform: "uppercase",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/host/new" element={<HostNew />} />
          <Route path="/host/game/:id" element={<HostGame />} />
          <Route path="/join" element={<Join />} />
          <Route path="/team/:id" element={<TeamRoom />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
